import styled from "styled-components";

export const ProjectHealthStyled = styled.div`
  height: 100%;
  .health{
    padding: 20px
  }
  .card {
    /* padding: 20px; */
    background-color: white;
    border: none;
  }
  .saveButton {
    display: flex;
    justify-content: flex-end;
    /* padding-bottom: 20px; */
  }
`;
